module.exports = __webpack_public_path__ + "static/media/logo.2b788b00.svg";